export const collectionListEditorBase = {
  props: {
    algoliaCollections: {
      type: Object,
      default: null,
    },
    collections: {
      type: Array,
      default: [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      default: () => null,
    },
  },
  watch: {
    collectionsCopy: {
      handler(value) {
        this.onChange(value);
      },
      deep: true,
    },
  },
  methods: { getNumberByIndex, getSelectedCollectionName, handleCollectionSelect, findCollectionItemIndex },
};

function getNumberByIndex(index) {
  const sequence = index + 1;
  return sequence < 10 ? `0${sequence}` : sequence;
}

function getSelectedCollectionName(viewComponent) {
  return this.algoliaCollections?.hits?.find((item) => item.id === viewComponent.entity_id)?.title || "";
}
function handleCollectionSelect(dropdownItem, viewComponent) {
  const index = this.findCollectionItemIndex(viewComponent);
  if (this.collectionsCopy[index]) {
    this.collectionsCopy[index].entity_id = dropdownItem.entity_id;
    this.collectionsCopy[index].info.link = "";
  }
}

function findCollectionItemIndex(viewComponent) {
  return this.collectionsCopy?.findIndex((item) => {
    return item.localId ? item.localId === viewComponent.localId : item.id === viewComponent.id;
  });
}
